import { SKILLS } from "@/data/content";

export default function Marquee() {
  const items = [...SKILLS, ...SKILLS];
  return (
    <div className="relative overflow-hidden border-y border-border bg-[#0A0A0A] py-6">
      <div className="marquee-track flex whitespace-nowrap will-change-transform">
        {items.map((s, i) => (
          <span
            key={i}
            className="font-mono-brut text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter uppercase mx-8 flex items-center gap-8"
          >
            <span className={i % 3 === 0 ? "text-[#E3FF00]" : "text-[#F4F4F0]"}>{s}</span>
            <span className="text-[#2A2A2A]">/</span>
          </span>
        ))}
      </div>
    </div>
  );
}
